<template>
    <div>
        <div class="columns">
            <div class="column">
                <e-field>
                    <display-content :content="activityContent.content" />
                </e-field>
            </div>
        </div>

        <div v-if="userHasAuthorizedAttempt || (!completed && !readOnly)" class="columns">
            <div class="column">
                <e-button :loading="isLoading" :disabled="disabled" type="is-primary" @click="submit" @keyup="submit">
                    {{ translate('mark_complete') }}
                </e-button>
            </div>
        </div>

        <div v-if="!readOnly && canViewSubmissions" class="columns">
            <div class="column">
                <submissions :namespace="namespace" @fetch-submissions="toggleSubmissionLoading" />
            </div>
        </div>
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { mapState } from 'vuex';

import Submissions from '@/components/activity-types/course-activity-types/activities/Submissions.vue';
import DisplayContent from '@/components/editor/DisplayContent.vue';
import AttemptAuthorizationMixin from '@/mixins/AttemptAuthorization.mixin.js';
import CourseActivityMixin from '@/mixins/CourseActivity.mixin.js';
import IsLateMixin from '@/mixins/IsLate.mixin.js';

export default {
    setup() {
        const { t: translate } = useI18n();
        return { translate };
    },
    name: 'ViewInformation',

    components: {
        DisplayContent,
        Submissions,
    },

    mixins: [IsLateMixin, CourseActivityMixin, AttemptAuthorizationMixin],

    computed: {
        ...mapState('Auth', { authUser: state => state.user }),

        payload() {
            return {
                uuid: this.activity.uuid,
                course_id: this.courseId,
                activity_id: this.activityId,
                activity_type: this.get('activity_type'),
                activity_submission: [],
            };
        },
    },
};
</script>
